t = require('app/scripts/views/internal/teacup-with-helpers')('logged_in_public_board_banner')

module.exports = t.renderable ({ isAdmin, isVisible, trelloForTeams, isTemplate }) ->
  if isVisible
    t.div '.logged-in-public-board-message', ->
      t.div '.logged-in-public-board-body', ->
        if trelloForTeams
          t.span -> t.format 'ready-for-more-productive-teamwork'
          t.a { class: 'button primary js-copy-board', href: '#' }, ->
            t.format 'copy-this-board'

        if isTemplate
          t.icon 'public', { class: 'icon-lg icon-public' }
          t.span ->
            if isAdmin
              t.format 'template-set-to-public-admin'
            else
              t.format 'template-set-to-public-visitors'
        else
          t.icon 'public', { class: 'icon-lg icon-public' }
          t.span ->
            if isAdmin
              t.format 'you-can-change-its-visibility-at-any-time'
            else
              t.format 'board-admins-can-change-its-visibility-setting-at-any-time'
        t.a { href: 'https://help.trello.com/article/789-changing-the-visibility-of-a-board-to-public-private-or-team' , target: '_blank', class: 'js-learn-more' }, ->
          t.format 'learn-more-here'

    t.a '.icon-lg.icon-close.js-close-banner', { href: '#' }
